import React from 'react'
import { propType } from 'graphql-anywhere'
import classnames from 'classnames'
import PropTypes from 'prop-types'
// import { sanitizeDom } from '../../utils'

import HTML_FRAGMENT from '../../../graphql/fragments/html.gql'
import styles from './html.css'
import { useScreenTheme } from '../../hooks/use-screen-theme'
import HTMLSurvey from './html-survey'
import HTMLCountdown from './html-countdown'
import HTMLHeader from './html-header'
import HTMLHeaderWithImage from './html-header-with-image'

const isSurveyMonkey = text => text.includes('smcx-sdk')
const isCountdownTimer = text => text.includes('countdown-timer')
const isHeaderContent = text => text.includes('header-text-only')
const isHeaderWithImageContent = text => text.includes('header-with-image')

function HTML({ html, position }) {
  const { isWhiteTheme, isMarketing } = useScreenTheme()

  // Replaces any instances of "http" with "https" to prevent Mixed Content issues
  const convertProtocol = copy => copy.replace(/http:/g, 'https:')

  if (isHeaderContent(html.header)) {
    return <HTMLHeader isFirstComponent={position === 0} />
  }

  if (isHeaderWithImageContent(html.header)) {
    return <HTMLHeaderWithImage isFirstComponent={position === 0} />
  }

  if (isSurveyMonkey(html.copy)) {
    return <HTMLSurvey copy={html.copy} />
  }

  if (isCountdownTimer(html.copy)) {
    return <HTMLCountdown copy={html.copy} />
  }

  return (
    <div
      className={classnames(styles.wrapper, {
        [styles.whiteTheme]: isWhiteTheme || isMarketing
      })}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: convertProtocol(html.copy) }}
    />
  )
}

HTML.propTypes = {
  html: propType(HTML_FRAGMENT).isRequired,
  position: PropTypes.number.isRequired
}

export default HTML
